import { render, staticRenderFns } from "./alarmXINGHENG.vue?vue&type=template&id=b3a21954&scoped=true"
import script from "./alarmXINGHENG.vue?vue&type=script&lang=js"
export * from "./alarmXINGHENG.vue?vue&type=script&lang=js"
import style0 from "./alarmXINGHENG.vue?vue&type=style&index=0&id=b3a21954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a21954",
  null
  
)

export default component.exports